// extracted by mini-css-extract-plugin
export default {"messagesInfo":"chats_messagesInfo__b0JGr","messages":"chats_messages__jYwI7"};